import { AboutView } from 'src/sections/about/about-view';

export default function AboutPage() {
  return <AboutView />;
}
